import React, { PureComponent } from 'react';

import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

class Label extends PureComponent {
  render() {
    const { children, required, className } = this.props;
    return (
      <div className={cx('Label', className)}>
        {children}
        {required && <span className={cx('required')}>*</span>}
      </div>
    );
  }
}

export default Label;
